import React from 'react'
import { KidDashboardDesktop } from '@/components/KidDashboardDesktop'

/**
 * Kid tiles page - Always shows the tile grid dashboard
 * Route: /dashboard/tiles (for kids on mobile)
 */
export const KidTilesPage: React.FC = () => {
  return <KidDashboardDesktop />
}
